import React, { Suspense, lazy } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "./index.css";
import { ThemeProvider } from "./ThemeContext";
import AppInitializer from "./core/AppInitializer";
import LoadingFallback from "./components/LoadingFallback";
import ErrorBoundary from "./components/ErrorBoundary";

// Lazy load non-critical components
const CookieConsentBanner = lazy(() => import("./components/CookieConsentBanner"));
const HomePage = lazy(() => import("./HomePage"));
const IndianMarketObservatory = lazy(() => import("./IndianMarketObservatory"));
const StockDetail = lazy(() => import("./components/StockDetail"));
const CalculatorsPage = lazy(() => import("./CalculatorsPage"));
const BrokersPage = lazy(() => import("./BrokersPage"));
const NotFoundPage = lazy(() => import("./NotFoundPage"));

const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(
    <React.StrictMode>
      <ErrorBoundary>
        <HelmetProvider>
          <BrowserRouter>
            <ThemeProvider>
              <AppInitializer>
                <Suspense fallback={<LoadingFallback />}>
                  <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/bubble-chart" element={<IndianMarketObservatory />} />
                    <Route path="/dashboard" element={<Navigate to="/bubble-chart" replace />} />
                    <Route path="/calculators" element={<CalculatorsPage />} />
                    <Route path="/calculators/:calcType" element={<CalculatorsPage />} />
                    <Route path="/brokers" element={<BrokersPage />} />
                    <Route path="/stock/:symbol" element={<StockDetail />} />
                    <Route path="*" element={<NotFoundPage />} />
                  </Routes>
                  <CookieConsentBanner />
                </Suspense>
              </AppInitializer>
            </ThemeProvider>
          </BrowserRouter>
        </HelmetProvider>
      </ErrorBoundary>
    </React.StrictMode>
  );
}
